module.exports = __webpack_public_path__ + "img/brand-logo.9db2bf6f.svg";